export const MESSAGE_TYPES = {
  MOCK_PURCHASE: 'GET_MOCK_DATA',
  CHANNEL_POINTS_SUBSCRIBE: 'CHANNEL_POINTS_SUBSCRIBE',
  CHANNEL_POINTS_UNSUBSCRIBE: 'CHANNEL_POINTS_UNSUBSCRIBE',
  IDENTIFY_CLIENT: 'IDENTIFY_CLIENT',
  NEW_REQUEST: 'NEW_REQUEST',
  START_VOTING: 'START_VOTING',
  SKIP_REQUEST: 'SKIP_REQUEST',
  VOTE_SKIP: 'VOTE_SKIP',
  VOTE_ANTI_SKIP: 'VOTE_ANTI_SKIP',

  DA_SUBSCRIBE: 'DONATION_ALERTS_SUBSCRIBE',
  DA_UNSUBSCRIBE: 'DONATION_ALERTS_UNSUBSCRIBE',

  REFUND_REWARD: 'REFUND_REWARD',
  CANCEL_ALL_REWARDS: 'CANCEL_ALL_REWARDS',

  PURCHASE: 'PURCHASE',
  SET_AUC_REWARD_PREFIX: 'SET_AUC_REWARD_PREFIX',
};

export const SERVER_MESSAGES = {
  DA_SUBSCRIBED: 'DONATION_ALERTS_SUBSCRIBED',
  DA_UNSUBSCRIBED: 'DONATION_ALERTS_UNSUBSCRIBED',
  DA_SUBSCRIBE_ERROR: 'DONATION_ALERTS_SUBSCRIBE_ERROR',

  CP_SUBSCRIBED: 'CP_SUBSCRIBED',
  CP_UNSUBSCRIBED: 'CP_UNSUBSCRIBED',
  CP_SUBSCRIBE_ERROR: 'CP_SUBSCRIBE_ERROR',
};
